import { render, staticRenderFns } from "./StickyFooterActionBar.vue?vue&type=template&id=1bec785e&lang=pug&"
import script from "./StickyFooterActionBar.vue?vue&type=script&lang=ts&"
export * from "./StickyFooterActionBar.vue?vue&type=script&lang=ts&"
import style0 from "./StickyFooterActionBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports